let Summary1950=[
    {"Countryname":" ",
    "OZ":0,
    "ME":9,
    "NU":14,
    "DI":14,
    "HR":31,
    "CO":75,
    "EC":22,
    "OT":0
    }]
export default Summary1950
